module.exports = __webpack_public_path__ + "img/otopack150-inactive.ea476146.svg";